import { Outlet, useParams } from 'react-router-dom';
import { RouteTabs } from '@/components/ui/RouteTabs';
import { Alert } from '@/components/ui/Alert';

const tabs = [
  { path: 'welcome', label: 'Welcome' },
  { path: 'reaction-roles', label: 'Reaction Roles' },
  { path: 'leveling', label: 'Leveling' },
  { path: 'booster', label: 'Booster Roles' },
  { path: 'giveaways', label: 'Giveaways' },
  { path: 'starboard', label: 'Starboard' },
  { path: 'suggestions', label: 'Suggestions' },
];

/**
 * docs/DASHBOARD_INFORMATION_ARCHITECTURE.md groups these 7 features under
 * one "Community" sidebar section with its own sub-navigation — this layout
 * is that sub-navigation, matching the pattern already used for Reaction
 * Roles' own internal tabs per docs/IMPLEMENTATION_PLAN.md Feature 8.
 */
export function CommunityLayout() {
  const { guildId } = useParams<{ guildId: string }>();
  const base = `/dashboard/${guildId}/community`;

  return (
    <div className="max-w-4xl space-y-6">
      <div>
        <h1 className="text-h1 text-text-primary mb-1">Community</h1>
        <p className="text-small text-text-secondary">
          Welcome messages, reaction roles, leveling, boosters, giveaways, starboard, and suggestions.
        </p>
      </div>

      <Alert
        tone="info"
        title="Not connected to your server yet"
        description="Every page in this section is an interactive preview — nothing is saved until Discord sign-in and the Bot Bridge exist."
      />

      <RouteTabs tabs={tabs.map((t) => ({ to: `${base}/${t.path}`, label: t.label }))} />

      <Outlet />
    </div>
  );
}
